module.exports = __webpack_public_path__ + "img/68.904e97c5.png";